import React from 'react'

function CreateBookMarkPopup({ errorMsg, setViewErrorPop }) {
    console.log("errorMsg", errorMsg)
    return (
        <div className=" successful_create_transprant_body ">
            <div className=" p-2 successful_create_container shadow">
                <img src="/images/alert.svg" alt="" />
                <span className=" my-4 successfully_create_message">
                    {errorMsg}
                </span>
                <button
                    onClick={() => setViewErrorPop(false)}
                    className="btn btn-danger px-4 py-2 successfull_create_okay_btn"
                >
                    Okay
                </button>
            </div>
        </div>
    )
}

export default CreateBookMarkPopup